import { Field } from '@mfe-types/field';

export const getMaxValue = (field: Field, fieldValues: Record<string, any>) => {
    if ('maxValue' in field) {
        return typeof field.maxValue === 'function' ? field.maxValue(fieldValues) : field.maxValue;
    }
    return undefined;
};

export const getMinValue = (field: Field, fieldValues: Record<string, any>) => {
    if ('minValue' in field) {
        return typeof field.minValue === 'function' ? field.minValue(fieldValues) : field.minValue;
    }
    return undefined;
};

export const getIncrementValue = (field: Field) => {
    if ('increment' in field && typeof field.increment === 'number') {
        return Math.abs(field.increment);
    }
    return undefined;
};

export const fillIncrementValues = (
    minValue: number,
    maxValue: number,
    increment: number,
): number[] => {
    const values = [];
    let n = minValue;

    // Add intermediate values starting with min value
    if (minValue !== undefined && maxValue !== undefined && increment !== undefined) {
        while (n <= maxValue) {
            values.push(Math.round(n * 100) / 100);
            n = n + increment;
        }
        // Add max value
        if (values[values.length - 1] !== maxValue) {
            values.push(maxValue);
        }
    }
    return values;
};

export const getIncrementValues = (field: Field, fieldValues: Record<string, any>) => {
    const minValue = getMinValue(field, fieldValues);
    const maxValue = getMaxValue(field, fieldValues);
    const increment = getIncrementValue(field);

    if (
        increment !== undefined &&
        minValue !== undefined &&
        maxValue !== undefined &&
        minValue <= maxValue
    ) {
        return fillIncrementValues(minValue, maxValue, increment);
    }
    return undefined;
};
